import React from 'react';
import { getThemeVariableValue } from '#app/containers/ThemeLoader';

export default function DotsMenuIcon({ color, ...props }) {
  const colorDots = getThemeVariableValue('color-text-primary') || '#4855b5';
  if (!color) {
    color = colorDots;
  }
  return (
    <svg
      width="4"
      height="16"
      viewBox="0 0 4 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.99996 8.83325C2.4602 8.83325 2.83329 8.46016 2.83329 7.99992C2.83329 7.53968 2.4602 7.16659 1.99996 7.16659C1.53972 7.16659 1.16663 7.53968 1.16663 7.99992C1.16663 8.46016 1.53972 8.83325 1.99996 8.83325Z"
        stroke={color}
        strokeWidth="1.667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.99996 2.99992C2.4602 2.99992 2.83329 2.62682 2.83329 2.16659C2.83329 1.70635 2.4602 1.33325 1.99996 1.33325C1.53972 1.33325 1.16663 1.70635 1.16663 2.16659C1.16663 2.62682 1.53972 2.99992 1.99996 2.99992Z"
        stroke={color}
        strokeWidth="1.667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.99996 14.6666C2.4602 14.6666 2.83329 14.2935 2.83329 13.8333C2.83329 13.373 2.4602 12.9999 1.99996 12.9999C1.53972 12.9999 1.16663 13.373 1.16663 13.8333C1.16663 14.2935 1.53972 14.6666 1.99996 14.6666Z"
        stroke={color}
        strokeWidth="1.667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
